import POSCustomerField from '../../../../POS/Fields/POSCustomerField';

import POSDateField from '../../../../POS/Fields/POSDateField';

import POSSelectField from '../../../../POS/Fields/POSSelectField';

import POSToolbarButton from '../../../../POS/Fields/POSToolbarButton';

interface Props {
  form: any;

  loading: boolean;

  fieldErrors: Record<string, string>;

  branchDropdown: any[];

  canOverrideAssignment: boolean;

  customersDropdown: any[];

  employeeDropdown: any[];

  updateField: (field: string, value: any) => void;

  handlerInitializeQuotation: () => void;

  handlerUpdateQuotationHeader: () => void;

  handlerResetQuotationFormOnly: () => void;

  reloadCustomersDropdown: () => void;

  saveCustomerQuick?: () => Promise<void> | void;

  showCustomerModal?: boolean;

  openCustomerModal?: () => void;

  closeCustomerModal?: () => void;
}

const QuotationHeaderFields: React.FC<Props> = ({
  form,

  fieldErrors,

  loading,

  branchDropdown,

  canOverrideAssignment,

  customersDropdown,

  employeeDropdown,

  updateField,

  handlerInitializeQuotation,

  handlerUpdateQuotationHeader,

  handlerResetQuotationFormOnly,

  reloadCustomersDropdown,

  saveCustomerQuick,

  showCustomerModal = false,

  openCustomerModal,

  closeCustomerModal,
}) => {
  return (
    <div
      className="
        flex
        flex-col
        gap-3

        xl:flex-row
        xl:items-end
      "
    >
      {/* ===================================================== */}
      {/* 🔹 Cliente */}
      {/* ===================================================== */}

      <div className="min-w-0 xl:flex-[2]">
        <POSCustomerField
          options={customersDropdown}
          selectedValue={form?.customer?.id || null}
          onSelect={(option) => updateField('customer', option)}
          onReload={reloadCustomersDropdown}
          onCustomerCreated={saveCustomerQuick}
          showCustomerModal={showCustomerModal}
          openCustomerModal={openCustomerModal}
          closeCustomerModal={closeCustomerModal}
          error={fieldErrors.customer}
        />
      </div>

      {/* ===================================================== */}
      {/* 🔹 Sucursal (solo ADMIN/SUPPORT/ACCOUNTANT) */}
      {/* ===================================================== */}

      {canOverrideAssignment && (
        <div className="min-w-0 xl:flex-1">
          <POSSelectField
            label="Sucursal"
            name="branch"
            iconKey="building"
            value={form?.branch?.id || ''}
            options={branchDropdown.map((branch) => ({
              label: branch.name,

              value: String(branch.id),
            }))}
            onChange={(e) =>
              updateField('branch', {
                id: Number(e.target.value),

                name: e.target.options[e.target.selectedIndex].text,
              })
            }
            error={fieldErrors.branch}
          />
        </div>
      )}

      {/* ===================================================== */}
      {/* 🔹 Vendedor (solo ADMIN/SUPPORT/ACCOUNTANT — el resto usa */}
      {/* siempre el usuario de la sesión) */}
      {/* ===================================================== */}

      {canOverrideAssignment && (
        <div className="min-w-0 xl:flex-1">
          <POSSelectField
            label="Vendedor"
            name="seller"
            iconKey="user"
            value={form?.seller?.id || ''}
            options={employeeDropdown.map((employee) => ({
              label: employee.name,

              value: String(employee.id),
            }))}
            onChange={(e) =>
              updateField('seller', {
                id: Number(e.target.value),

                name: e.target.options[e.target.selectedIndex].text,
              })
            }
            error={fieldErrors.seller}
          />
        </div>
      )}

      {/* ===================================================== */}
      {/* 🔹 Fecha */}
      {/* ===================================================== */}

      <div className="min-w-0 xl:w-[220px]">
        <POSDateField
          label="Vencimiento"
          name="expirationDate"
          value={form?.expirationDate || ''}
          onChange={(date) => updateField('expirationDate', date)}
          error={fieldErrors.expirationDate}
        />
      </div>

      {/* ===================================================== */}
      {/* 🔹 Actions */}
      {/* ===================================================== */}

      <div
        className="
          flex
          items-end
          justify-end
          gap-2
        "
      >
        {/* 🔴 Reset */}

        <POSToolbarButton
          icon="trash"
          variant="danger"
          title="Limpiar"
          onClick={handlerResetQuotationFormOnly}
          disabled={loading}
        />

        {/* 🟢 Save */}

        <POSToolbarButton
          icon={form?.id ? 'edit' : 'save'}
          variant={form?.id ? 'info' : 'success'}
          disabled={loading}
          loading={loading}
          title={form?.id ? 'Actualizar' : 'Guardar'}
          onClick={() =>
            form?.id
              ? handlerUpdateQuotationHeader()
              : handlerInitializeQuotation()
          }
        />
      </div>
    </div>
  );
};

export default QuotationHeaderFields;
